/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Button, Dialog } from '@coursera/cds-core';

import CredentialsInfoDialogItem from 'bundles/account-profile/components/recruiting-profile-viewer/components/credentials/CredentialsInfoDialogItem';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/account-profile';

type PropsFromCaller = {
  isOpen: boolean;
  onClose: () => void;
  includeBadgeInfo?: boolean;
};

const styles = {
  dialogInfoItemsContainer: () => css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-300);
  `,
};

type PropsToComponent = PropsFromCaller;

export const CredentialsInfoDialog = ({ isOpen, onClose, includeBadgeInfo }: PropsToComponent) => {
  const dialogInfoItems = [
    {
      title: _t('Professional Certificates'),
      description: _t(
        'Career-focused credentials from industry leaders that demonstrate candidates’ expertise and job readiness.'
      ),
    },
    {
      title: _t('Specializations'),
      description: _t(
        'A series of courses and projects that provides candidates with in-depth knowledge of a subject.'
      ),
    },
  ];
  if (includeBadgeInfo) {
    dialogInfoItems.push({
      title: _t('Learning Paths'),
      description: _t(
        'A sequence of courses and projects curated by your organization, recognized by a digital badge.'
      ),
    });
  }
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Credentials')}</Dialog.HeadingGroup>
      <Dialog.Content>
        <TrackedDiv
          trackClicks={false}
          requireFullyVisible={false}
          withVisibilityTracking
          // not tracked in eventing v3
          trackingName="profile_education_history_info_dialog"
          css={styles.dialogInfoItemsContainer}
        >
          {dialogInfoItems.map((item) => (
            <div key={item.title}>
              <CredentialsInfoDialogItem title={item.title} description={item.description} />
            </div>
          ))}
        </TrackedDiv>
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="primary" onClick={onClose}>
          {_t('Got it')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default CredentialsInfoDialog;
